module.exports = __webpack_public_path__ + "static/media/reversed-logo.279dfecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reversed-logo.png
// module id = 1300
// module chunks = 0